import { Link, useNavigate, useLocation } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
import Conponents from "./Conponents.js";
import General from "./General.js";
import Attributes from "./Attributes.js";
import Pricing from "./Pricing.js";
import Header from "../../../../../../header/header.js";
import Navvbar from "../../../../../../header/Navvbar.js";
import OutsourcePricing from "./outSourcePricing.js";
import Sidebar from "../../../../../../Sidebar.js";
import "./AddLabProcedureReportTable.css";

const AddLabProcedureReportTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {};
  const [activeTab, setActiveTab] = useState("General");

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleCancel = () => {
    navigate("/caseSetting");
  };

  return (
    <>
      <Header />
      <Navvbar />
      <br />

      <div className="alprt-main-wrapper">
        <div className="alprt-layout">

          {/* ===== SIDEBAR ===== */}
          <aside className="alprt-sidebar">
            <Sidebar />
          </aside>

          {/* ===== CONTENT ===== */}
          <section className="alprt-content">

            <h3 className="alprt-content-title">
              {item ? "Edit Procedure" : "Add Procedure"}
            </h3>

            <div className="alprt-tabs-container">
              <Tabs
                activeKey={activeTab}
                onSelect={handleTabSelect}
                id="uncontrolled-tab-example"
                className="alprt-tabs"
              >

                {/* GENERAL */}
                <Tab eventKey="General" title="General">
                  <General
                    procedureData={item}
                    onCancel={handleCancel}
                  />
                </Tab>

                {/* ATTRIBUTES - NOW WORKING */}
                <Tab eventKey="Attributes" title="Attributes">
                  <Attributes
                    procedureData={item}
                    onCancel={handleCancel}
                  />
                </Tab>

                {/* PRICING */}
                <Tab eventKey="Pricing" title="Pricing">
                  <Pricing
                    procedureData={item}
                    onCancel={handleCancel}
                  />
                </Tab>

                {/* OUTSOURCE PRICING */}
                <Tab
                  eventKey="OutsourcePricing"
                  title="OutsourcePricing"
                >
                  <OutsourcePricing
                    procedureData={item}
                    onCancel={handleCancel}
                  />
                </Tab>

                {/* COMPONENT - NOW WORKING */}
                <Tab eventKey="Component" title="Component" disabled>
                  <Conponents
                    procedureData={item}
                    onCancel={handleCancel}
                  />
                </Tab>

              </Tabs>
            </div>
          </section>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default AddLabProcedureReportTable;